export default __webpack_public_path__ + "static/media/lock-icon.2239cb4b.svg";